// selectClassNames.js

// Function to generate select class names based on parameters
const getSelectClassNames = ({
  isDisabled,
  selectProps,
  isSelected,
  value,
  bgWhite,
  errorsBorder,
  extraClass,
}) => ({
  menuButton: () => {
    return `flex w-full ${
      value === "" || value === undefined || isDisabled
        ? "text-gray-400"
        : `text-gray-900 ${
            extraClass ? extraClass?.darkTextGray : "dark:text-white"
          } `
    } rounded-md ${
      errorsBorder ? "border-red-500" : ""
    } relative border dark:!border-white/10 text-md overflow-hidden transition-all outline-none duration-300 focus:outline-none ${
      isDisabled
        ? "cursor-not-allowed"
        : `${
            extraClass ? extraClass?.darkBgWhite : "dark:bg-transparent"
          } bg-white cursor-pointer`
    } ${extraClass ? extraClass?.paddingY : ""}`;
  },
  menu: "absolute top-10 z-10 w-full bg-white dark:bg-gray-900 shadow-lg border rounded py-1 mt-1.5 text-sm text-gray-700",
  listItem: () => {
    return `block  transition bg-white duration-200 px-2 py-4 cursor-pointer select-none truncate rounded ${
      isSelected
        ? "text-white"
        : "text-gray-500 hover:bg-blue-100 hover:text-blue-500"
    }`;
  },
});

// Export the function
export default getSelectClassNames;
